import { MODULE_PREFIX } from './constants';
import type { MapState } from './types';

export const mapSelector = (state): MapState => state[MODULE_PREFIX];
